import { PaymentMethodCard } from "./PaymentMethodCard";
import { PaymentSummary } from "../types/PaymentTypes";

interface PaymentMethodGridProps {
  summaries: PaymentSummary[];
  visibleMethods: Set<string>;
  expandedMethods: Set<string>;
  onCountedChange: (method: string, value: string) => void;
  onToggleExpand: (method: string) => void;
  onTransactionSelect?: (method: string, transactionId: string, checked: boolean) => void;
  selectedTransactions?: Record<string, Set<string>>;
}

export const PaymentMethodGrid = ({
  summaries,
  visibleMethods,
  expandedMethods,
  onCountedChange,
  onToggleExpand,
  onTransactionSelect,
  selectedTransactions = {},
}: PaymentMethodGridProps) => {
  return (
    <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
      {summaries
        .filter((summary) => visibleMethods.has(summary.method))
        .map((summary) => (
          <PaymentMethodCard
            key={summary.method}
            method={summary.method}
            amount={summary.amount}
            counted={summary.counted}
            transactions={summary.transactions}
            onCountedChange={(value) => onCountedChange(summary.method, value)}
            isExpanded={expandedMethods.has(summary.method)}
            onToggleExpand={() => onToggleExpand(summary.method)}
            isValidated={summary.isValidated}
            onTransactionSelect={onTransactionSelect ?
              (transactionId, checked) => onTransactionSelect(summary.method, transactionId, checked) :
              undefined}
            selectedTransactions={selectedTransactions[summary.method]}
          />
        ))}
    </div>
  );
};